import SETTINGS from "settings";

const socket_path = SETTINGS.url_params['socket_path'] !== undefined ? decodeURIComponent(SETTINGS.url_params['socket_path']) : null;

let TimeIdDisconnect = null;

export default function( space, MathClass, game_id )
{
    const socket = io(
        'https://wbgdev.ngmcasino.com',
        {
            path: socket_path ? socket_path : '/nard_server/socket/socket.io',
            // path: socket_path ? socket_path : '/wbg_socket/socket.io', // for wbg jp test
            query: 'minigame_id=' + ( MathClass.getGameID ? MathClass.getGameID() : game_id ),
        }
    )

    let clearTimeIdDisconnect = () => {
        if (TimeIdDisconnect) {
            clearTimeout(TimeIdDisconnect);
            TimeIdDisconnect = null;
        }
    };

    socket.on('connect', () => {
        console.log("========== connected");
        clearTimeIdDisconnect();
    });

    // считаем сервер инициализированным не после socket.on('connect'),
    // а когда получим первую модель от сервера
    // это на случай ошибки при запросе первой модели - нужно показывать лоадинг и пендинг пока она не придет
    let initialized = false;
    space.s('net')
        .filter(arg => arg)
        .on(() => {
            if (!initialized) {
                initialized = true;
                space.s('server_initialized').next(true);
            }
        })

    const $error = space.s( 'error' )
    function handle_error( name ) {
        socket.on( name, () => {
            console.log( '===========', name )
            clearTimeIdDisconnect();
            // delay before show disconnect tab
            TimeIdDisconnect = setTimeout(() => {
                $error.next({type: 'fail', message: name})
            }, 2000)
        } )
    }
    handle_error( 'disconnect' )
    handle_error( 'connect_failed' )
    handle_error( 'connect_error' )
    handle_error( 'connect_timeout' )
    handle_error( 'reconnect_error' )
    handle_error( 'reconnect_failed' )
    
    const mathNet = new MathClass( socket, game_id )
    mathNet.setVerbose(true);
    
    mathNet.cb_account_changed = p => space.s( 'balance_poll' ).next( p )
    mathNet.cb_model_changed = m => space.s( 'net' ).next( m )
    mathNet.cb_model_outdated = e => space.s( 'error' ).next( { type : 'fail', message : e } )
    mathNet.cb_jackpot_changed = j => space.s( 'progressive_jackpot' ).next( j )
    mathNet.cb_unauthorised = () => {goLobby()};
    mathNet.cb_account_selection_changed = data => {
        space.s( 'account_selection_changed' ).next( data );
        mathNet.doSetGameAccountToPlayerActiveAccount();
        // сброс текущей ставки произойдет в __validateModel
    };
    
    const $result = space.s( 'server_result' )
    function handle_action( { name, param, bet } ) {
        //making args:
        const args = []
        //TODO: maybe move bet into model?
        if ( bet ) {
            mathNet.setBetValue( bet )
            args.push( bet )
        }
        //first arg is parameters object if needed:
        if ( param !== undefined && param !== null ) args.push( param )
        //second arg is callback which we redirect to appropriate streams:
        const cb = ( err, result ) => {
            if ( err || ! result ) $error.next( {
                type : 'fail',
                message : name + ': ' + JSON.stringify( err ) + ', result: ' + JSON.stringify( result ),
            } )
            
            if ( result ) $result.next( result )
        }
        args.push( cb )
        
        //TODO: maybe call .setBetValue() here too?
        
        const method = mathNet[ name ]
        if ( method ) mathNet[ name ].apply( mathNet, args )
        else mathNet.m_minigame_connector.doAction( name, param, cb )
    }
    space.s( 'server_action' ).on( a => {
        if ( Array.isArray( a ) ) for ( const v of a ) handle_action( v )
        else handle_action( a )
    })

    space.s( 'beforeGoLobby' )
        .on(() => {
            console.log('goLobby - removeAllListeners from socket for not showing disconnect anim');
            socket.off('disconnect');
        });

    space.s( 'beforeGoLobby' ).to(space.s('goToLobby'));

    space.s( 'resetGame' )
        .on(() => {
            console.log('resetGame');
            socket.close();
            socket.open();
        });
}

export function goLobby()
{
    window.space.s('beforeGoLobby').next();

    let lobbyURL = null;
    if (SETTINGS.url_params['lobby_url'] !== undefined) lobbyURL = decodeURIComponent(SETTINGS.url_params['lobby_url']);
    if (SETTINGS.url_params['back_url'] !== undefined)  lobbyURL = decodeURIComponent(SETTINGS.url_params['back_url']);

    if (lobbyURL) {
        console.log('redirecting to', lobbyURL, '...');
        window.location.replace(lobbyURL);
    }
    else {
        console.log('sending', 'game_close', 'message to iframe host ...');
        window.top.postMessage("game_close", "*");
    }
}


// WEBPACK FOOTER //
// ./src/library/minigame_client/minigame_client.es6